var map = {
	"./1.png": "201d",
	"./2.png": "1b48",
	"./3.png": "2cfe",
	"./4.png": "dcb4",
	"./5.png": "ce2f",
	"./6.png": "708b",
	"./7.png": "5d55",
	"./A.png": "3937",
	"./B.png": "b21a",
	"./C.png": "2b0ec",
	"./D.png": "8d91",
	"./E.png": "e614",
	"./F.png": "9aac",
	"./G.png": "0e11",
	"./H.png": "432c",
	"./I.png": "09c1",
	"./J.png": "3240",
	"./K.png": "178c",
	"./L.png": "722a",
	"./SVG/Asset 191.png": "50be",
	"./SVG/full-conveyor.svg": "3340",
	"./SVG/pipes.svg": "b92b",
	"./SVG/screen.svg": "e9e6",
	"./SVG/test-conveyor.svg": "846c",
	"./SVG/test-conveyor1.png": "4b19",
	"./full-conveyor.svg": "2c95",
	"./glenn-carstens-peters.jpg": "5697",
	"./screen.svg": "2a3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07b8";